import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpEventType } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { ApiService } from "src/app/services/api";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { CookieService } from "ngx-cookie-service";
import { BlurEvent, ChangeEvent } from "@ckeditor/ckeditor5-angular";
import Adapter from "src/app/core/services/ckeditorAdapter";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// @Component({
//   selector: 'app-editsupporttickets',
//   templateUrl: './editsupporttickets.component.html',
//   styleUrls: ['./editsupporttickets.component.scss']
// })
@Component({
  selector: 'app-editsuppportticketsmerchant',
  templateUrl: './editsuppportticketsmerchant.component.html',
  styleUrls: ['./editsuppportticketsmerchant.component.scss']
})
export class EditsuppportTicketsMerchantComponent implements OnInit, OnDestroy {
  breadcrumbItems: breadcrumbItem[] = [
    { label: 'Home', active: false, url: "/home" },
    { label: 'Support Tickets', active: false, url: "/support-tickets-merchant" },
    { label: 'Update Support Ticket', active: true, url: "/support-tickets-merchant/update" },
  ];

  public componentEvents: string[] = [];
  public editorContent: string = ''; // CKEditor content
  public Editor = ClassicEditor;

  merchantIssueId: string;
  merchantIssueForm: FormGroup;
  commentForm: FormGroup;
  replyForms: FormGroup[] = [];
  replyVisibility: boolean[] = [];
  isLoadingChangeSub: Subscription;
  merchantIssue: any;
  GLOBALURL = this.apiService.getBaseURL();
  isReadonly: boolean = true; // Set this to true or false based on your condition
  showAllComments: boolean = false;
  files: File[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private store: Store<AppState>,
    private toastr: AlertService,
    private apiService: ApiService,
    private breadcrumbService: BreadcrumbService,
    private changeDetector: ChangeDetectorRef,
    private cookieService: CookieService,

  ) { }

  ngOnInit(): void {
    this.breadcrumbService.setValue(this.breadcrumbItems);
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.route.params.subscribe(params => {
      this.merchantIssueId = params['id'];
      this.initializeForms();
      this.fetchData();
    });
  }

  ngOnDestroy(): void {
    if (this.isLoadingChangeSub) {
      this.isLoadingChangeSub.unsubscribe();
    }
  }

  initializeForms() {
    this.merchantIssueForm = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      status: ['', Validators.required]
    });

    this.commentForm = this.fb.group({
      commentText: ['', Validators.required]
    });
  }

  fetchData() {
    this.getDetails();
  }

  getDetails(): void {
    const params = { merchantIssueId: this.merchantIssueId };
    this.http.get(this.GLOBALURL + "/merchants/issues", { params }).subscribe(
      (response: any) => {
        if (response.success === 1) {
          this.merchantIssue = response.response;
          this.populateForm();
          this.initializeReplyForms();
          setTimeout(() => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
          }, 2000);
          console.log('Merchant Issue:', this.merchantIssue);
        } else {
          this.toastr.clear();
          this.toastr.error(response.message);
          this.store.dispatch(setLoadingSpinner({ status: false }));
        }
      },
      (error) => {
        const message = this.apiService.errorMessage(error);
        this.toastr.clear();
        this.toastr.error(message);
        this.store.dispatch(setLoadingSpinner({ status: false }));
      }
    );
  }

  populateForm(): void {
    this.merchantIssueForm.patchValue({
      title: this.merchantIssue.issueTitle,
      description: this.merchantIssue.description,
      status: this.merchantIssue.status
    });
  }

  initializeReplyForms(): void {
    this.merchantIssue.comments.forEach((comment: any, index: number) => {
      this.replyForms[index] = this.fb.group({
        replyText: ['', Validators.required]
      });
      this.replyVisibility[index] = false;
    });
  }

  toggleReplyForm(index: number, comment: any): void {
    console.log('Toggling reply form for index:', index, comment);
    this.replyVisibility[index] = !this.replyVisibility[index];
    this.changeDetector.detectChanges();
  }

  addReply(commentId: string, index: number): void {
    if (this.replyForms[index].valid) {
      const replyData = {
        comments: this.replyForms[index].get('replyText').value,
        merchantIssueId: this.merchantIssueId,
        employeeName: this.merchantIssue?.employeeName || this.cookieService.get('employeeName'),
        commentId: commentId
      };

      this.http.post(this.GLOBALURL + "/issues/comments", replyData).subscribe(
        (response: any) => {
          if (!response.error) {
            this.replyForms[index].reset();
            this.toastr.success("Reply added successfully.");
            this.getDetails();
            // this.router.navigate(["/master/device"]);
          } else {
            this.toastr.clear();
            this.toastr.error(response.message);
          }
        },
        (error) => {
          const message = this.apiService.errorMessage(error);
          this.toastr.clear();
          this.toastr.error(message);
        }
      );

      // const replyUrl = `${this.apiService.getBaseURL()}/comments/replies`;
      // this.http.post(replyUrl, replyData).subscribe({
      //   next: (res) => {
      //     this.toastr.success('Reply added successfully.');
      //     this.merchantIssue.comments[index].commentReplays.push(res['reply']); // Adjust based on the actual backend response
      //     this.replyForms[index].reset();
      //     // this.toggleReplyForm(index); // Close the form upon successful submission
      //   },
      //   error: (error) => {
      //     this.toastr.error('Error adding reply: ' + error.message);
      //   }
      // });
    }
  }

  onSubmit(): void {
    if (!this.merchantIssueForm.valid) {
      this.toastr.error('Please fill out the form correctly.');
      return;
    }
    const updateUrl = `${this.apiService.getBaseURL()}/merchants/issues/update/${this.merchantIssueId}`;
    this.http.put(updateUrl, this.merchantIssueForm.value).subscribe(response => {
      this.toastr.success('Issue updated successfully');
      this.router.navigate(['/support-tickets']);
    });
  }
  stripHtmlTags(html: string): string {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  }
  addComment(): void {
    if (!this.commentForm.valid) {
      this.toastr.error('Please enter all required fields.');
      return;
    }
    const strippedContent = this.stripHtmlTags(this.commentForm.controls.commentText.value);

    // const deviceInfodata = this.deviceForm.value.deviceInfo;
    const payload: any = {
      comments: this.commentForm.controls.commentText.value,
      merchantIssueId: this.merchantIssueId,
      employeeName: this.merchantIssue?.employeeName || this.cookieService.get('employeeName'),
    };

    this.http.post(this.GLOBALURL + "/issues/comments", payload).subscribe(
      (response: any) => {
        if (!response.error) {
          this.commentForm.reset();
          this.toastr.success("comments added successfully.");
          this.getDetails();
          // this.router.navigate(["/master/device"]);
        } else {
          this.toastr.clear();
          this.toastr.error(response.message);
        }
      },
      (error) => {
        const message = this.apiService.errorMessage(error);
        this.toastr.clear();
        this.toastr.error(message);
      }
    );
  }
  getFormattedDate(date: number): string {
    const myDate = new Date(date * 1000); // Convert Unix timestamp to milliseconds

    const day = ('0' + myDate.getDate()).slice(-2);
    const month = myDate.toLocaleString('default', { month: 'short' });
    const year = myDate.getFullYear();
    const hours = ('0' + myDate.getHours()).slice(-2);
    const minutes = ('0' + myDate.getMinutes()).slice(-2);
    const seconds = ('0' + myDate.getSeconds()).slice(-2);

    const formattedDate = `${day} ${month}, ${year} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  }


  onChange(event: ChangeEvent): void {
    console.log("onCange", event.editor?.getData());
    this.componentEvents.push('Editor model changed.');
  }

  onFocus(event: FocusEvent): void {
    this.componentEvents.push('Focused the editing view.');
  }

  onBlur(event: BlurEvent): void {
    this.componentEvents.push('Blurred the editing view.');
  }
  onReady(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      console.log("OnReady_LOADER", loader);
      console.log("OnReady_EDITOR", editor);
      return new Adapter(loader, editor.config);;
    };
  }

  onFilesAdded(event: any): void {
    const MAX_SIZE = 5242880; // 5MB in bytes

    for (let file of event.addedFiles) {
        if (file.size > MAX_SIZE) {
            this.toastr.error(`File ${file.name} exceeds the maximum size of 5MB.`);
            return; // Exit the function, do not add any files to array or call upload
        }
    }

    // If the loop completes without returning, all files are valid
    this.files.push(...event.addedFiles);

    // Add existing attachment URLs as 'files', converted as Blob
    // this.merchantIssue.attachments.forEach(url => {
      // Suppose we treat existing attachments
      // const blob = new Blob([url], { type: 'text/plain' });
      // const file = new File([blob], 'attachment-url.txt', { type: 'text/plain' });
      // this.files.push(file);
  // });

    this.uploadFiles(); // Proceed with uploading valid files
}

  onRemoveFile(file: File): void {
    this.files.splice(this.files.indexOf(file), 1);
  }

  // uploadFiles(): void {
  //   const formData = new FormData();
  //   formData.append('merchantIssueId', this.merchantIssueId); // Add merchantIssueId to FormData
  
  //   const allFiles = [...(this.merchantIssue.attachments || []), ...this.files];
  
  //   // Append all files to FormData
  //   allFiles.forEach(file => {
  //     if (typeof file === 'string') {
  //       // Assuming attachments are URLs, convert them to Blob
  //       const blob = new Blob([file], { type: 'text/plain' });
  //       formData.append('files', blob, file);
  //     } else {
  //       formData.append('files', file);
  //     }
  //   });
  
  //   console.log('Uploading files:', this.files);
  //   // Adjust the URL to your needs
  //   this.http.put(this.GLOBALURL + 'merchants/issues', formData, {
  //     reportProgress: true,
  //     observe: 'events'
  //   }).subscribe(event => {
  //     if (event.type === HttpEventType.UploadProgress) {
  //       const progress = Math.round(100 * event.loaded / event.total);
  //       console.log(`Upload progress: ${progress}%`);
  //     } else if (event.type === HttpEventType.Response) {
  //       console.log('Files successfully uploaded!', event.body);
  //       this.toastr.success('Files uploaded successfully.');
  //       this.getDetails(); // Refresh the data after upload
  //       this.files = []; // Clear files after upload
  //     }
  //   }, error => {
  //     console.error('Upload failed:', error);
  //     this.toastr.error('Failed to upload files.');
  //   });
  // }
  uploadFiles(): void {
    const formData = new FormData();
    formData.append('merchantIssueId', this.merchantIssueId); // Add merchantIssueId to FormData

    // Append only new files directly selected by the user for uploading
    this.files.forEach(file => {
      formData.append('files', file); // Directly append File objects
    });

    console.log('Uploading new files:', this.files);

    // Adjust the URL to your needs
    this.http.put(this.GLOBALURL + '/merchants/issues', formData, {
        reportProgress: true,
        observe: 'events'
    }).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
            const progress = Math.round(100 * event.loaded / event.total);
            console.log(`Upload progress: ${progress}%`);
        } else if (event.type === HttpEventType.Response) {
            console.log('Files successfully uploaded!', event.body);
            this.toastr.success('Files uploaded successfully.');
            this.getDetails(); // Refresh the data after upload
            this.files = []; // Clear the array of files after successful upload
        }
    }, (error) => {
        console.error('Upload failed:', error);
        this.toastr.error('Failed to upload files.');
    });
}
  closeIssue(): void {
    this.updateIssueStatus(1); // 1 for closed
  }

  reopenIssue(): void {
    this.updateIssueStatus(0); // 0 for open
  }

  updateIssueStatus(status: number): void {
    const payload = {
      merchantIssueId: this.merchantIssueId,
      issueStatus: status
    };

    this.http.put(this.GLOBALURL + "/merchants/issues/status", payload).subscribe(
      (response: any) => {
        if (!response.error) {
          this.toastr.success("Issue updated successfully.");
          // this.router.navigate(["/master/device"]);
          this.getDetails();
        } else {
          this.toastr.clear();
          this.toastr.error(response.message);
        }
      },
      (error) => {
        const message = this.apiService.errorMessage(error);
        this.toastr.clear();
        this.toastr.error(message);
      }
    );
  }

  removeAttachment(attachment: any): void {
    console.log("removeAttachment", attachment);
   

    // Find the index of the attachment in the array
  const index = this.merchantIssue.attachments.indexOf(attachment);

  // Check if the attachment exists in the array
  if (index !== -1) {
    // Remove the attachment from the array
    this.merchantIssue.attachments.splice(index, 1);
  } else {
    // Optional: Handle the case where the attachment is not found
    console.log('Attachment not found');
  }
  // add merchantIssueId to the merchantIssue
  this.merchantIssue.merchantIssueId = this.merchantIssueId || this.merchantIssue._id;
    console.log("this.merchantIssue", this.merchantIssue);
    
    this.http.put(this.GLOBALURL + "/merchants/issues", this.merchantIssue).subscribe(
      (response: any) => {
        if (!response.error) {
          this.toastr.success("Attachment removed successfully.");
          this.getDetails(); // Refresh the data to update the attachments list
        } else {
          this.toastr.clear();
          this.toastr.error(response.message);
        }
      },
      (error) => {
        const message = this.apiService.errorMessage(error);
        this.toastr.clear();
        this.toastr.error(message);
      }
    );
  }
}